import { useMemo } from 'react';
import useUserNavigation from './useUserNavigation';
import { useOffersSummaryQuery } from 'src/app/queries/offers.queries';
import { useCurrentMerchant } from 'src/app/queries/merchant.queries';
import { is0420Merchant } from 'src/app/utils/mccUtils';

export default function useEnhancedUserNavigation(role: string | undefined) {
  const userNavigation = useUserNavigation();

  const shouldFetchOffers = role === 'merchant';
  const { data: offersSummary, isLoading } = useOffersSummaryQuery(shouldFetchOffers);
  const { data: merchantData } = useCurrentMerchant({ enabled: role === 'merchant' });
  const merchantMcc = merchantData?.data?.mcc;
  const is0420MerchantUser = is0420Merchant(merchantMcc);

  return useMemo(() => {
    let filteredNavigation = userNavigation;

    // Filter out "Get Started!" menu item for 0420 merchants (MCC ID 1)
    if (role === 'merchant' && is0420MerchantUser) {
      filteredNavigation = userNavigation.filter((item) => item.id !== 'merchant-get-started');
    }

    if (!shouldFetchOffers || isLoading) {
      return filteredNavigation;
    }

    const { offerCount, hasActiveOffer } = offersSummary?.data ?? {};

    if (hasActiveOffer) {
      return filteredNavigation;
    }

    return filteredNavigation.map((item) => {
      if (item.id !== 'merchant-offers-component') {
        return item;
      }

      if (offerCount) {
        return {
          ...item,
          badge: {
            title: offerCount.toString(),
            bg: '#91D500',
            fg: '#111827',
            classes: 'custom-offer-badge',
          },
        };
      }

      return item;
    });
  }, [shouldFetchOffers, isLoading, userNavigation, offersSummary, role, is0420MerchantUser]);
}
